import { LANG } from "~/utils/constant";
import { useLanguageParams } from "./useLanguageParams";

export const useFontStyle = () => {
  const lang = useLanguageParams();

  return {
    // combination of mokubrush and baloobhai2 fonts

    regular: lang === LANG.english ? "font-abcArizonaFlareVariable font-normal" : "font-baloobhai2Regular",
    medium: lang === LANG.english ? "font-abcArizonaFlareVariable font-medium" : "font-baloobhai2Medium",
    semiBold: lang === LANG.english ? "font-abcArizonaFlareVariable font-semibold" : "font-baloobhai2Semibold",
    bold: lang === LANG.english ? "font-abcArizonaFlareVariable font-bold" : "font-baloobhai2bold",
    extraBold: lang === LANG.english ? "font-abcArizonaFlareVariable font-extrabold" : "font-baloobhai2ExtraBold",

    // regular: lang === LANG.english ? "font-abcArizonaFlareVariable font-normal" : "font-muktavaaniRegular",
    // medium: lang === LANG.english ? "font-abcArizonaFlareVariable font-medium" : "font-muktavaaniMedium",
    // semiBold: lang === LANG.english ? "font-abcArizonaFlareVariable font-semibold" : "font-muktavaaniSemibold",
    // bold: lang === LANG.english ? "font-abcArizonaFlareVariable font-bold" : "font-muktavaanibold",
    // extraBold: lang === LANG.english ? "font-abcArizonaFlareVariable font-extrabold" : "font-muktavaaniExtraBold",

    // regular: lang === LANG.english ? "font-abcArizonaFlareVariable font-normal" : "font-ghanuRegular font-normal",
    // medium: lang === LANG.english ? "font-abcArizonaFlareVariable font-medium" : "font-ghanuRegular font-medium",
    // semiBold: lang === LANG.english ? "font-abcArizonaFlareVariable font-semibold" : "font-ghanuRegular font-semibold",
    // bold: lang === LANG.english ? "font-abcArizonaFlareVariable font-bold" : "font-ghanuRegular font-bold",
    // extraBold: lang === LANG.english ? "font-abcArizonaFlareVariable font-extrabold" : "font-ghanuRegular font-extrabold",

    // regular: lang === LANG.english ? "font-mokubrushRegular" : "font-baloobhai2Regular",
    // medium: lang === LANG.english ? "font-mokubrushMedium" : "font-baloobhai2Medium",
    // semiBold: lang === LANG.english ? "font-mokubrushSemibold" : "font-baloobhai2Semibold",
    // bold: lang === LANG.english ? "font-mokubrushBlack" : "font-baloobhai2bold",
    // extraBold: lang === LANG.english ? "font-mokubrushBlack" : "font-baloobhai2ExtraBold",

    // mediumInter: lang === LANG.english ? "font-inter font-medium" : "font-baloobhai2Medium",
    // normalInter: lang === LANG.english ? "font-inter font-normal" : "font-baloobhai2Regular",
    // semiBoldInter: lang === LANG.english ? "font-inter font-semibold" : "font-baloobhai2Semibold",

    // // combination of tai heritage pro and baloobhai2 fonts
    // regular: lang === LANG.english ? "font-taiHeritageProRegular" : "font-baloobhai2Regular",
    // medium: lang === LANG.english ? "font-taiHeritageProMedium" : "font-baloobhai2Medium",
    // semiBold: lang === LANG.english ? "font-taiHeritageProSemibold" : "font-baloobhai2Semibold",
    // bold: lang === LANG.english ? "font-taiHeritageProBlack" : "font-baloobhai2bold",
    // extraBold: lang === LANG.english ? "font-taiHeritageProBlack" : "font-baloobhai2ExtraBold",

    // // combination of noto sans and baloobhai2 fonts
    // mediumInter: lang === LANG.english ? "font-notoSansMedium" : "font-baloobhai2Medium",
    // normalInter: lang === LANG.english ? "font-notoSansRegular" : "font-baloobhai2Regular",
    // semiBoldInter: lang === LANG.english ? "font-notoSansSemiBold" : "font-baloobhai2Semibold",

    // arima and baloobhai2 fonts
    // regular: lang === LANG.english ? "font-arimaRegular" : "font-baloobhai2Regular",
    // medium: lang === LANG.english ? "font-arimaMedium" : "font-baloobhai2Medium",
    // semiBold: lang === LANG.english ? "font-arimaSemibold" : "font-baloobhai2Semibold",
    // bold: lang === LANG.english ? "font-arimaBlack" : "font-baloobhai2bold",
    // extraBold: lang === LANG.english ? "font-arimaBlack" : "font-baloobhai2ExtraBold",

    // combination of outfit and baloobhai2 fonts
    mediumInter: lang === LANG.english ? "font-outfitMedium" : "font-baloobhai2Medium",
    normalInter: lang === LANG.english ? "font-outfitRegular" : "font-baloobhai2Regular",
    mediumGujInter: "font-baloobhai2Medium",
    normalGujInter: "font-baloobhai2Regular",
    semiBoldInter: lang === LANG.english ? "font-outfitSemiBold" : "font-baloobhai2Semibold",

    // mediumInter: lang === LANG.english ? "font-outfitMedium" : "font-ghanuRegular font-medium",
    // normalInter: lang === LANG.english ? "font-outfitRegular" : "font-ghanuRegular font-normal",
    // semiBoldInter: lang === LANG.english ? "font-outfitSemiBold" : "font-ghanuRegular font-semibold",
  };
};
